<template>
  <v-navigation-drawer
    app
    permanent
    :width="250"
    class="modern-sidebar">
    
    <!-- Logo Section -->
    <div class="logo-section">
      <img 
        src="@/../public/static/img/acrew-logo-with-effects-white.png" 
        alt="Acrew Logo" 
        class="sidebar-logo" />
    </div>

    <!-- Navigation Items -->
    <v-list class="nav-list">
      <v-list-item
        v-for="menuItem in menuArray"
        :key="menuItem.title"
        :to="menuItem.link"
        :href="menuItem.href"
        :target="menuItem.target"
        class="nav-item"
        :class="{ 'nav-item--active': isActiveRoute(menuItem) }"
        active-class="nav-item--active">
        <v-list-item-icon class="nav-icon">
          <v-icon>{{ menuItem.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="nav-title">{{ menuItem.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Logout Button -->
      <v-list-item class="nav-item" @click="onLogout">
        <v-list-item-icon class="nav-icon">
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="nav-title">LOGOUT</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import DataService from '../../../_services/DataService';
import { loadClientPreferences } from '../../utils/UxUtils';
export default {
  data() {
    return {
      permission: '',
      menuArray: [],
      page: '/dashboard',
      clientColor: '',
      patient: [
        {
          icon: 'mdi-home',
          title: 'Dashboard',
          link: '/dashboard',
        },
        {
          icon: 'mdi-calendar',
          title: 'Schedule',
          link: '/patient_schedule',
        },
        {
          icon: 'mdi-account',
          title: 'My Account',
          link: '/account',
        },
      ],
      clientAdmin: [
        {
          icon: 'mdi-home',
          title: 'Dashboard',
          link: '/dashboard',
        },
        {
          icon: 'mdi-email',
          title: 'Messaging',
          link: '/messaging',
        },
        {
          icon: 'mdi-shield-account-outline',
          title: 'Admin',
          link: '/admin',
        },
        {
          icon: 'mdi-chart-line',
          title: 'Reporting',
          link: '/reporting',
        },
        {
          icon: 'mdi-account',
          title: 'My Account',
          link: '/account',
        },
      ],
      clientUser: [
        {
          icon: 'mdi-home',
          title: 'Dashboard',
          link: '/dashboard',
        },
        {
          icon: 'mdi-email',
          title: 'Messaging',
          link: '/messaging',
        },
        {
          icon: 'mdi-shield-account-outline',
          title: 'Admin',
          link: '/admin',
        },
        {
          icon: 'mdi-chart-line',
          title: 'Reporting',
          link: '/reporting',
        },
        {
          icon: 'mdi-account',
          title: 'My Account',
          link: '/account',
        },
      ],
      mini: true,
    };
  },
  computed: {},
  
  async mounted() {
    // Get client color for branding
    await loadClientPreferences(this);

    switch (DataService.getRole()) {
    case 'clientAdmin':
      this.menuArray = this.clientAdmin;
      break;
    case 'patient':
      this.menuArray = this.patient;
      break;
    case 'clientUser':
      this.menuArray = this.clientUser;
      break;
    default:
      this.menuArray = [];
    }
  },
  watch: {
    $route() {
      this.page = this.$route.path;
      this.loggedin = this.userIsAuthenticated();
    },
  },
  methods: {
    userIsAuthenticated() {
      let isAuthenticated = false;
      if (localStorage.getItem('user')) isAuthenticated = true;
      return isAuthenticated;
    },
    onLogout() {
      this.$root.$emit('logout');
      DataService.logout();
    },
    isActiveRoute(item) {
      if (item.link === '/scheduled_appointments' && (this.$route.path === '/scheduled_appointments' || this.$route.path === '/patient_schedule')) {
        return true;
      }
      if (item.link === '/patient_schedule' && (this.$route.path === '/scheduled_appointments' || this.$route.path === '/patient_schedule')) {
        return true;
      }
      if (item.link === '/reporting' && this.$route.path === '/reporting') {
        return true;
      }
      return this.$route.path === item.link;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/variables.scss';

// Component-specific colors
$sidebar-bg-primary: #133b54;
$sidebar-bg-secondary: #1a365d;
$nav-active-bg: #b0d35e;
$nav-active-text: #414a5b;
$nav-text-color: rgba(255, 255, 255, 0.85);
$nav-hover-bg: rgba(255, 255, 255, 0.08);
$logo-border: rgba(255, 255, 255, 0.1);

.modern-sidebar {
  background: linear-gradient(180deg, $sidebar-bg-primary 0%, $sidebar-bg-secondary 100%) !important;
  border-right: none !important;
}

.logo-section {
  padding: 32px 24px;
  text-align: center;
  border-bottom: 1px solid $logo-border;
}

.sidebar-logo {
  max-width: 180px;
  height: auto;
}

.nav-list {
  padding: 24px 0;
  background: transparent !important;
}

.nav-item {
  margin: 6px 16px;
  border-radius: 8px;
  padding: 14px 16px;
  min-height: 52px;
  transition: background-color $transition-normal $easing-smooth, transform $transition-normal $easing-smooth, box-shadow $transition-normal $easing-smooth;
  
  &:hover {
    background-color: $nav-hover-bg !important;
    transform: translateX($transform-slide);
  }
  
  &--active {
    background-color: $nav-active-bg !important;
    transform: translateX($transform-slide);
    box-shadow: $shadow-nav-active;
    
    .nav-icon .v-icon,
    .nav-title {
      color: $nav-active-text !important;
    }
    
    &:hover {
      background-color: $nav-active-bg !important;
      
      .nav-icon .v-icon,
      .nav-title {
        color: $nav-active-text !important;
      }
    }
  }
}

.nav-icon {
  margin-right: 16px !important;
  min-width: 24px;
  
  .v-icon {
    color: $nav-text-color;
    font-size: 22px;
    transition: color $transition-normal ease;
  }
}

.nav-title {
  color: $nav-text-color !important;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  transition: color $transition-normal ease;
}

// Override Vuetify defaults
.v-navigation-drawer .v-list-item--active::before {
  opacity: 0 !important;
}

.v-list-item__icon {
  align-self: center;
}

.v-list-item__content {
  align-self: center;
}
</style>
